import React, {memo} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

interface Props {
  selected?: moment.MomentInput;
  onChange?: (value: Date) => void;
  showTimeSelect?: boolean;
  selectsRange?: boolean;
  onChangeDateRange?: (value: Date[]) => void;
  filterDate?: (date: Date) => boolean;
  startDate?: Date;
  endDate?: Date;
  isModal?: boolean;
  maxDate?: Date;
  minDate?: Date;
  placeholderText?: string;
  dateFormat?: string;
  [key: string]: any;
}

export const AppDatePicker = memo(function AppDatePicker({
  selected,
  onChange,
  showTimeSelect,
  selectsRange,
  onChangeDateRange,
  filterDate,
  startDate,
  endDate,
  isModal,
  placeholderText,
  maxDate,
  minDate,
  dateFormat,
  ...rest
}: Props) {
  const selectedDate = selected ? moment(selected).toDate() : undefined;

  const onChangeLocal = (value: any) => {
    if (!selectsRange && !!onChange) {
      onChange(value);
    } else if (!!selectsRange && !!onChangeDateRange) {
      onChangeDateRange(value);
    }
  };

  let dateFormatLocal = dateFormat || 'yyyy/MM/dd';

  if (showTimeSelect) {
    dateFormatLocal = 'yyyy/MM/dd HH:mm:ss';
  }

  return (
    <DatePicker
      showTimeSelect={showTimeSelect}
      dateFormat={dateFormatLocal}
      selected={selectedDate}
      onChange={onChangeLocal}
      selectsRange={selectsRange}
      startDate={startDate}
      endDate={endDate}
      withPortal={isModal}
      placeholderText={placeholderText}
      maxDate={maxDate}
      minDate={minDate}
      filterDate={filterDate}
      {...rest}
    />
  );
});
